import React from "react";
import connectofr from "../../images/sponsors/connectofr.png";
import DAN from "../../images/sponsors/DAN.png";
import django from "../../images/sponsors/django.png";
import Drona from "../../images/sponsors/Drona-Foundation.png";
import Holy from "../../images/sponsors/Holy-Cross-Kurla.png";
import Jamnabai from "../../images/sponsors/Jamnabai-Narsee-School-black.png";
import kc from "../../images/sponsors/kc-college-1.png";
import Kohinoor from "../../images/sponsors/Kohinoor-Business-School_1.png";
import Life_Vest_Inside_Logo_transparent from "../../images/sponsors/Life_Vest_Inside_Logo_transparent.png";
import Little from "../../images/sponsors/Little-Sisters-of-the-Poor.png";
import MAD from "../../images/sponsors/MAD_LOGO_11-4-17-1.png";
import mcubed from "../../images/sponsors/MCubed-Library.png";
import roti from "../../images/sponsors/Mumbai-Roti-Bank.png";
import NSPA from "../../images/sponsors/NSPA.png";
import parleshwar from "../../images/sponsors/parleshwar-1.png";
import rotary from "../../images/sponsors/Rotary-Club.png";
import schbang from "../../images/sponsors/schbang.png";
import smash from "../../images/sponsors/Smaaash.png";
import sparsha from "../../images/sponsors/Sparsha-Charitable-Trust_transparency.png";
import andrews from "../../images/sponsors/St.-Andrews-college.png";
import TitleWaves from "../../images/sponsors/Title-Waves.png";
import toiing from "../../images/sponsors/toiing.png";
import trilogy from "../../images/sponsors/Trilogy.png";
import villa from "../../images/sponsors/Villa-Teresa-school.png";
import sporting from "../../images/sponsors/WhatsApp-Image-2020-03-15-at-8.19.45-AM-1.png";
import projectMumbai from "../../images/sponsors/WhatsApp-Image-2021-02-15-at-22.54.58-1.png";
import society from "../../images/sponsors/WhatsApp-Image-2021-02-15-at-22.54.58-2.png";
import sneha from "../../images/Snehavardhini.png";
import sgi from "../../images/SGI.png";
import thyssenkrupp from "../../images/Thyssenkrupp.png";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import LogoGrid from "../ui/LogoGrid";

const sections = [
  {
    title: "Project Partners",
    logos: [
      { src: rotary, name: "Rotary Club" },
      { src: society, name: "Society Tea" },
      { src: Life_Vest_Inside_Logo_transparent, name: "Life Vest Inside" },
      { src: roti, name: "Roti Bank" },
      { src: connectofr, name: "ConnectFor" },
      { src: NSPA, name: "NSPA" },
      { src: smash, name: "Smaaash" },
      { src: toiing, name: "Toiing" },
      { src: sneha, name: "Snehavardhini Social Trust" },
      { src: sgi, name: "Sustainable Green Initiative" },
    ],
  },
  { title: "CSR Partners", logos: [{ src: thyssenkrupp, name: "Thyssenkrupp" }] },
  {
    title: "NGO Partners",
    logos: [
      { src: parleshwar, name: "Rotary Club of Mumbai" },
      { src: projectMumbai, name: "Project Mumbai" },
      { src: sporting, name: "Sporting Lions" },
      { src: sparsha, name: "Sparsha Charitable Trust" },
      { src: Drona, name: "Drone Foundation" },
      { src: Little, name: "Home for the Aged" },
      { src: MAD, name: "Make a Difference" },
    ],
  },
  {
    title: "Digital Partners",
    logos: [
      { src: schbang, name: "Schbang" },
      { src: django, name: "Django Digital" },
      { src: DAN, name: "Dentsu Aegis Network" },
    ],
  },
  {
    title: "Venue Partners",
    logos: [
      { src: mcubed, name: "Mcubed Library" },
      { src: TitleWaves, name: "Title Waves" },
      { src: trilogy, name: "Trilogy" },
    ],
  },
  {
    title: "Education Partners",
    logos: [
      { src: villa, name: "Villa Theresa High School" },
      { src: Holy, name: "Holy Cross High School, Kurla" },
      { src: andrews, name: "St. Andrews College, Bandra" },
      { src: Kohinoor, name: "Kohinoor Business School" },
      { src: Jamnabai, name: "Jamnabai Narsee School" },
      { src: kc, name: "KC College" },
    ],
  },
];

const Collaborations = () => (
  <PageLayout>
    <PageHero title="Collaborations" subtitle="Partners who amplify our mission of kindness across India." light />
    <section className="ku-section bg-white">
      <div className="ku-container">
        {sections.map((section) => (
          <LogoGrid key={section.title} title={section.title} logos={section.logos} />
        ))}
      </div>
    </section>
  </PageLayout>
);

export default Collaborations;
